import { AllEnums, Enum } from '~/data/enums';

import {
  CustomFieldTypes,
  CustomFieldValues,
  FieldAttributes,
  FieldAttributesHash,
  ReadCustomField,
} from '../types';

import {
  filterEnumsByCountry,
  jsNumber,
  jsSelectName,
  jsToEUDate,
  sortEnumLables,
} from './common';

function jsCustomFieldValue(
  customFields: CustomFieldValues,
  field: FieldAttributes,
  allEnums: AllEnums,
): string {
  if (!field) {
    return '';
  }

  const strName = field.fCustomDataAttributeName;
  const strType = field.fCustomDataAttributeDataType;
  const fieldVal = customFields[strName];
  if (Array.isArray(fieldVal)) {
    return fieldVal
      .map((elem: string) =>
        jsSelectName(
          allEnums[`${field.fCustomDataAttributeDataSubtype}`],
          elem,
        ),
      )
      .slice(0, 2)
      .join(', ');
  } else {
    switch (strType) {
      case CustomFieldTypes.DATE:
        return jsToEUDate(fieldVal);
      case CustomFieldTypes.TEXT:
        return fieldVal;
      case CustomFieldTypes.STRING:
        return fieldVal;
      case CustomFieldTypes.NUMBER:
        return jsNumber(parseFloat(fieldVal)) !== 'NaN'
          ? jsNumber(parseFloat(fieldVal))
          : '';
      case CustomFieldTypes.BOOLEAN:
        return fieldVal;
      case CustomFieldTypes.ENUM:
        return jsSelectName(
          allEnums[`${field.fCustomDataAttributeDataSubtype}`],
          fieldVal,
        );

      default:
        return '';
    }
  }
}

export const readCustomData = (
  strEntity: string,
  customFieldAttributesHash: FieldAttributesHash,
  customFields: CustomFieldValues,
  legalEntityCountry: string,
  allEnums: AllEnums,
): ReadCustomField[] => {
  const labels = filterEnumsByCountry(
    allEnums[`CUSTOM_ENTITY_${strEntity}`],
    '',
    legalEntityCountry,
  );
  const sortedLabels = labels.sort(sortEnumLables);
  return sortedLabels.map((label: Enum): ReadCustomField => {
    const info = label.details ? label.details : '';
    const field = customFieldAttributesHash[label.code];
    return {
      name: label.name,
      info,
      value: jsCustomFieldValue(customFields, field, allEnums),
      type: field.fCustomDataAttributeDataType,
    };
  });
};
